// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  hmr: false,
  logging: {
    level: 'DEBUG',
    disableConsoleLogging: false,
  },
  // Google Tag Manager ID/GA ID
  gtm: {
    // Leave blank to avoid firing at GTM, see google-analytics.service.ts
    id: '',
  },
  // Maps api key
  maps: {
    apikey: 'AIzaSyAZoS6mZP5TJXPI0gtuZqmbcjLFcM4xn3s',
    staticContentBucket:
      'https://s3.eu-west-2.amazonaws.com/bucket.engineius.sandbox-static-content/icons/',
  },
  stripe: {
    publishableKey:
      'pk_test_51R6DRxLBTkCabzUGmKKCwJ54zpi3oiAWvfXZok0s7JpmzXF3AvRLfqdRA1tQtnmemzCkLAjBKugOxCogMnTJV1vM00czNusJ2d',
  },
  // appSync: {
  //   devConnectUrl:
  //     'wss://tu7e3s2ffbdhdibva52nq3ocnu.appsync-realtime-api.eu-west-2.amazonaws.com/graphql?payload=e30=&header=eyJob3N0IjoidHU3ZTNzMmZmYmRoZGlidmE1Mm5xM29jbnUuYXBwc3luYy1hcGkuZXUtd2VzdC0yLmFtYXpvbmF3cy5jb20iLCJ4LWFwaS1rZXkiOiJkYTItN3NvemRzdGp3emIzZGJwZTZ6cjU1b21kbWkifQ==',
  //   devSubscribeJSON:
  //     '{"id":"954737c5-fd76-4673-b14a-0345dc9edf74","payload":{"data":"{\\"query\\":\\"\\\\n      subscription SubscribeToChannel($channel: String!) {\\\\n        subscribe(name: $channel) {\\\\n          name,\\\\n          data\\\\n        }\\\\n      }\\\\n    \\",\\"variables\\":{\\"channel\\":\\"DriverInfo\\"}}","extensions":{"authorization":{"Authorization":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1laWQiOiJmNzZjNDQ0Mi05Y2M2LTQ5NDgtOWIzYS00MzkzMWVlZTI1MDIiLCJ1bmlxdWVfbmFtZSI6ImRhdmlkLmJyb3duQGVuZ2luZWl1cy5jby51ayIsIk9yZ2FuaXNhdGlvbklkIjoiMSIsIk9yZ2FuaXNhdGlvblR5cGVJZCI6IjEiLCJuYmYiOjE3MTcwNTg3ODUsImV4cCI6MTcxNzA4NzU4NSwiaWF0IjoxNzE3MDU4Nzg1fQ.GUfp_sBqKq6jBQUl9tKATSS_ex8hcjocCdextjdqbEI","host":"tu7e3s2ffbdhdibva52nq3ocnu.appsync-api.eu-west-2.amazonaws.com"}}},"type":"start"}',
  // },
  title: {
    suffix: 'Engineius',
  },
  recaptcha: {
    siteKey: 'X',
  },
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
